export const EVENT_FEASTS = [
  {
    name: "Angkor Feast",
    price: "$79",
    childPrice: "$45",
    note: "A generous Cambodian banquet built around ANGKOR signatures.",
    arrival: null,
    starters:
      "Betel Leaf · Cambodian Fish Cake · Homemade Spring Rolls · Marinated Chicken Skewer",
    salads: "Cambodian Papaya Salad",
    mains:
      "Fish Amok · Beef Loc Lac · Traditional Red Curry, chicken or vegetable",
    sides: "Steamed Jasmine Rice · Asian Roti",
    dessert: "Sticky Rice with Mango",
  },
  {
    name: "Royal Khmer Event Feast",
    price: "$99",
    childPrice: "$49",
    note: "The fuller celebration table, with a welcome drink and premium menu.",
    arrival: "Sparkling wine or Angkor Lemon Sunset Soda",
    starters:
      "Betel Leaf · Cambodian Fish Cake · BBQ Scallop* · Prawn Wontons · Marinated Beef Skewer",
    salads: "Green Mango Salad with prawns · Banana Blossom Salad",
    mains:
      "Fish Amok · My Grandmother’s Dish · BBQ Beef Steak · Kampot Pepper Seafood",
    sides: "Steamed Jasmine Rice · Asian Roti",
    dessert:
      "Sticky Rice with Mango · Black Rice Pudding · Homemade Coconut Ice Cream",
  },
] as const;

export const VENUE_MINIMUMS = [
  ["Weekday lunch", "Tue–Fri", "$1,500"],
  ["Weekend lunch", "Sat–Sun", "$2,000"],
  ["Weeknight dinner", "Tue–Thu", "$2,500"],
  ["Sunday dinner", "20% Sunday surcharge applies", "$2,750"],
  ["Friday & Saturday dinner", "Peak nights", "$3,500"],
] as const;

export const DRINK_PACKAGES = [
  {
    name: "Soft",
    price: "$20 pp · 3 hours",
    detail:
      "Soft drinks, sparkling water, juices and Lemongrass Ginger Iced Tea. Children $12.",
  },
  {
    name: "Classic",
    price: "$49 · $59 · $69 pp",
    detail:
      "Two, three or four hours. Beer, house sparkling, white, rosé and red, plus soft drinks.",
  },
  {
    name: "Royal",
    price: "$69 · $79 · $89 pp",
    detail:
      "Two, three or four hours. Classic package, premium wines, bottled beers and cider, plus an Angkor Tropical on arrival.",
  },
  {
    name: "Bar tab",
    price: "Set your limit",
    detail:
      "Choose the drinks available at menu prices, or let guests purchase their own drinks.",
  },
] as const;

export const EVENT_TYPES = [
  "Weddings",
  "Engagements",
  "Civil-marriage dinners",
  "Birthdays",
  "Corporate functions",
  "Celebrations",
] as const;
